import { waitForTransactionReceipt } from 'viem/actions';
import { parseOpenEvent } from './parseOpenEvent.js';
export async function waitForOrderOpen(params) {
    const receipt = await waitForTransactionReceipt(params.client, {
        hash: params.txHash,
        pollingInterval: params.pollingInterval,
    });
    return parseOpenEvent(receipt.logs);
}
//# sourceMappingURL=waitForOrderOpen.js.map